import { ViewFactory } from 'wdc-cube-react'
import { DateTimePickerScope } from '../DateTimerPicker.scopes'
import { DateTimePickerView } from './DateTimePicker.view'

export function registerViews(rv = ViewFactory.register) {
    rv(DateTimePickerScope, DateTimePickerView)
}
